import { schema } from "normalizr";
import View from "./view";

export default new schema.Array(View);
